/**
 * ProcurementLayout — Issue #331
 *
 * 采购模块侧边导航：服务目录 / 供应商 / 采购订单。
 */
import { useLocation } from 'wouter';
import type { ReactNode } from 'react';

const NAV_ITEMS = [
  { path: '/procurement/service-catalogs', label: '服务目录' },
  { path: '/procurement/suppliers', label: '供应商' },
  { path: '/procurement/purchase-orders', label: '采购订单' },
];

export default function ProcurementLayout({ children }: { children: ReactNode }) {
  const [location, navigate] = useLocation();
  return (
    <div className="flex min-h-full gap-6">
      <nav className="w-44 shrink-0">
        <ul className="space-y-1">
          {NAV_ITEMS.map((item) => {
            const isActive = location.startsWith(item.path);
            return (
              <li key={item.path}>
                <button
                  onClick={() => navigate(item.path)}
                  className={`w-full rounded-md px-3 py-2 text-left text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary text-primary-foreground'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}
